export var Topic;
(function (Topic) {
    Topic["REPUBLISH"] = "REPUBLISH";
    Topic["ACTIVE_CASE"] = "ACTIVE_CASE";
    Topic["ACTIVE_USER"] = "ACTIVE_USER";
    Topic["OUTLET_CONFIGURATION"] = "OUTLET_CONFIGURATION";
    Topic["ADD_PARTS"] = "ADD_PARTS";
    Topic["ADD_FLAT_RATE_UNITS"] = "ADD_FLAT_RATE_UNITS";
    Topic["ADD_DEFECTS"] = "ADD_DEFECTS";
    Topic["ADD_PACKAGES"] = "ADD_PACKAGES";
    Topic["ADD_JOBS"] = "ADD_JOBS";
    Topic["ADD_EMPTY_JOB"] = "ADD_EMPTY_JOB";
    Topic["REMOVE_JOBS"] = "REMOVE_JOBS";
    Topic["UPDATE_META_DATA"] = "UPDATE_META_DATA";
    Topic["UPDATE_JOB"] = "UPDATE_JOB";
    Topic["CASE_MODIFIED"] = "CASE_MODIFIED";
    Topic["DELETE_CASE"] = "DELETE_CASE";
    Topic["CONFIGURATION_PROPERTY"] = "APPLICATION_PROPERTY";
    Topic["NOTIFY_INFO"] = "NOTIFY_INFO";
    Topic["NOTIFY_SUCCESS"] = "NOTIFY_SUCCESS";
    Topic["NOTIFY_WARNING"] = "NOTIFY_WARNING";
    Topic["NOTIFY_ERROR"] = "NOTIFY_ERROR";
    Topic["OIDC_TOKEN"] = "OIDC_TOKEN";
    Topic["OPEN_CASE_BY_VIN"] = "OPEN_CASE_BY_VIN";
    Topic["NEWS_COUNT"] = "NEWS_COUNT";
    Topic["NAVIGATE_TO"] = "NAVIGATE_TO";
    Topic["CLIENT_INITIALIZATION"] = "CLIENT_INITIALIZATION";
})(Topic || (Topic = {}));
//# sourceMappingURL=topic.js.map